import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  AppBar,
  Box,
  Button,
  Container,
  IconButton,
  Toolbar,
  Typography,
  MenuItem,
  Menu,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';

const NavBar: React.FC = () => {
  const navigate = useNavigate();

  const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(
    null,
  );

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleRedirect = (url: string) => {
    handleCloseNavMenu();
    navigate(url);
  };

  return (
    <AppBar position="static" color="transparent" className="navBar">
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <Typography
            variant="h6"
            noWrap
            component="a"
            href="/"
            className="appTitle"
            sx={{
              mr: 2,
              display: { xs: 'none', md: 'flex' },
              fontFamily: 'monospace',
              fontWeight: 700,
              letterSpacing: '.3rem',
              color: 'inherit',
              textDecoration: 'none',
            }}
          >
            Champions Guild
          </Typography>

          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: 'block', md: 'none' },
              }}
            >
              <MenuItem onClick={() => handleRedirect('/players')}>
                <Typography textAlign="center">Players</Typography>
              </MenuItem>
              <MenuItem onClick={() => handleRedirect('/compare-players')}>
                <Typography textAlign="center">Compare players</Typography>
              </MenuItem>
              <MenuItem onClick={() => handleRedirect('/leaderboards')}>
                <Typography textAlign="center">Leaderboards</Typography>
              </MenuItem>
              <MenuItem onClick={() => handleRedirect('/about')}>
                <Typography textAlign="center">About</Typography>
              </MenuItem>
            </Menu>
          </Box>
          <Typography
            variant="h5"
            noWrap
            component="a"
            href="/"
            className="appTitle"
            sx={{
              mr: 2,
              display: { xs: 'flex', md: 'none' },
              flexGrow: 1,
              fontFamily: 'monospace',
              fontWeight: 700,
              letterSpacing: '.3rem',
              color: 'inherit',
              textDecoration: 'none',
            }}
          >
            Champions Guild
          </Typography>
          <Box
            sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}
            color="transparent"
          >
            <Button
              onClick={() => handleRedirect('/players')}
              sx={{ my: 2, color: 'white', display: 'block' }}
            >
              Players
            </Button>
            <Button
              onClick={() => handleRedirect('/compare-players')}
              sx={{ my: 2, color: 'white', display: 'block' }}
            >
              Compare players
            </Button>
            <Button
              onClick={() => handleRedirect('/leaderboards')}
              sx={{ my: 2, color: 'white', display: 'block' }}
            >
              Leaderboards
            </Button>
            <Button
              onClick={() => handleRedirect('/about')}
              sx={{ my: 2, color: 'white', display: 'block' }}
            >
              About
            </Button>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default NavBar;
